import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import { createMuiTheme, FormGroup, MuiThemeProvider, TableCell, Typography, withStyles, Tooltip, Snackbar } from "@material-ui/core";
import api from '../api';
import format from 'date-fns/format';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import editIcon from '../../assets/1@3x.png';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MuiAlert from '@material-ui/lab/Alert';
import Loader from 'react-loader-spinner'
import Constant from '../../library/Constant';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
// const options = ct.customOptions()

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const style = {
    position: "sticky",
    zIndex: 110
};

export default function ReportAppointment(props) {
    const [dataTable, setDataTable] = useState([])
    const [dataFilter, setDataFilter] = useState(null)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [dataCount, setDataCount] = useState(10)
    const [validFrom, setValidFrom] = useState(null)
    const [validTo, setValidTo] = useState(null)
    const [detailID, setDetailID] = useState(null)
    const [tanggal, setTanggal] = useState(null)
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getDataTable()
        setValidFrom(new Date())
        setValidTo(new Date())
    }, [])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getDataTable = (a, b) => {
        let dateFrom = a ? format(new Date(a), 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd')
        let dateTo = b ? format(new Date(b), 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd')
        api.create().getReportScheduleDoctorByDate(dateFrom, dateTo).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = []
                        response.data.data.map((item, index) => {
                            data.push([
                                // index + 1,   
                                item.polyclinic_name,
                                item.doctor_name,
                                item.schedule_date,
                                item.schedule_date,
                                item.schedule_time,
                                item.service_type,
                                item.total_quota === null ? 0 : item.total_quota,
                                item.quota_bpjs === null ? 0 : item.quota_bpjs,
                                item.total_all_reservation === null ? 0 : item.total_all_reservation,
                                item.total_general_reservation === null ? 0 : item.total_general_reservation,
                                item.total_insurance_reservation === null ? 0 : item.total_insurance_reservation,
                                item.total_bpjs_reservation === null ? 0 : item.total_bpjs_reservation,
                                item.total_cancel_reservation === null ? 0 : item.total_cancel_reservation,
                                item.last_queue_number === null ? 0 : item.last_queue_number,
                                item.doctor_detail_id,
                                item.doctor_phone,
                                item.doctor_id
                            ])
                        })
                        setDataTable(data)
                        setLoading(false)
                    } else {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("warning")
                        setLoading(false)

                    }
                }
            }
        })
    }

    // const getCopyText = (detailID, tanggal) => {
    //     api.create().getCopyText().then(response => {
    //         console.log(response);
    //         if (response.data) {
    //             if (response.data.status === true) {
    //                 let data = []
    //                 response.data.data.map((item) => {
    //                     data.push([item])
    //                 })
    //             }
    //         }
    //     })
    // }

    const updateDateRange = (a, b) => {
        setLoading(true)
        console.log(a, b);
        getDataTable(a, b)
        // const c = dataTable.filter((item) => {
        //     return Number(format(new Date(item[3]), 'yyyyMMdd')) >= Number(a) && Number(format(new Date(item[3]), 'yyyyMMdd')) <= Number(b)
        // });
        // setDataFilter(c)
        forceUpdate()

    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: true,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        rowsPerPage: 10,
        responsive: 'scrollMaxHeight',
        onFilterChange: (columnChanged, filterList) => {
            if (columnChanged === null) {
                setDataFilter(null)
                setValidFrom(null)
                setValidTo(null)
                getDataTable()
            }
        }
    };

    // const copyText = ({ rowData }) => {
    //     console.log(rowData);
    //     api.create().getCopyText(rowData[16], rowData[3] ? rowData[3] : format(new Date(), 'yyyy-MM-dd')).then(response => {
    //         console.log(response);
    //         if (response.data) {
    //             if (response.data.status === true) {
    //                 let data = []
    //                 let ket = ''
    //                 response.data.data.map((i, idx) => {
    //                     data.push([
    //                         `${idx === 0 ? `Reminder jadwal praktek\nDokter ${i.name}\n` : ''}`
    //                     ])
    //                     i.detail.length > 0 && i.detail.map((item, index) => {
    //                         data.push([
    //                             `Pada ${String(item.polyclinic_name).replace('&', 'dan')}\n`
    //                         ])
    //                         item.session.length > 0 && item.session.map((items, indexs) => {
    //                             data.push([
    //                                 `${indexs === 0 ? `Memiliki jadwal tanggal ${format(new Date(items.schedule_date), 'dd-MM-yyyy')} pada:\n` : ''}`
    //                             ])
    //                             data.push([
    //                                 `${indexs + 1}. Pukul : ${String(items.time_start).substring(0, 5)} - ${String(items.time_end).substring(0, 5)}\n    Kuota : ${items.quota ? String(items.quota) : '-'}\n    Total reservasi sebanyak : ${items.total_reservation ? String(items.total_reservation) : '0'}\n    Lokasi praktek : ${items.location ? String(items.location) : '-'}\n ${indexs + 1 === item.session.length ? '\n' : ''}`
    //                             ])
    //                         })
    //                     })

    //                     // items.session.length > 0 && i.session.map((item, index) => {
    //                     //     data.push([
    //                     //         `Pukul : ${String(item.time_start).substring(0, 5)} - ${String(item.time_end).substring(0, 5)}\nKuota : ${item.quota ? String(item.quota) : '-'}\nTotal reservasi sebanyak : ${item.total_reservation ? String(item.total_reservation) : '0'}\nLokasi praktek : ${item.location ? String(item.location) : '-'}\n`
    //                     //     ])
    //                     // })

    //                 })
    //                 console.log(data);
    //                 if (data.length > 0) {
    //                     let fix = ``
    //                     data.map((item, index) => {
    //                         let a = item
    //                         let b = encodeURI(a)
    //                         fix += b
    //                     })
    //                     console.log(fix);
    //                     if (rowData[15]) {
    //                         window.open(`https://wa.me/62${rowData[15]}?text=${fix}`, '_blank');
    //                     } else {
    //                         setMessageAlert("Nomor HP Dokter Tidak Ditemukan")
    //                         setStatusAlert('warning')
    //                         setOpenAlert(true)
    //                     }
    //                 }
    //             }
    //         }

    //     })
    // }

    const copyText = ({ rowData }) => {
        console.log(rowData);
        api.create().getCopyText(rowData[16], rowData[3] ? rowData[3] : format(new Date(), 'yyyy-MM-dd')).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    let ket = ''
                    response.data.data.map((i, idx) => {
                        data.push([
                            `${idx === 0 ? `Reminder jadwal praktek\nDokter ${i.name}\n` : ''}`
                        ])
                        i.detail.length > 0 && i.detail.map((item, index) => {
                            data.push([
                                `Pada *${String(item.polyclinic_name).replace('&', 'dan')}*\n`
                            ])
                            item.session.length > 0 && item.session.map((items, indexs) => {
                                data.push([
                                    `${indexs === 0 ? `Memiliki jadwal tanggal ${format(new Date(items.schedule_date), 'dd-MM-yyyy')} pada:\n` : ''}`
                                ])
                                data.push([
                                    `${indexs + 1}. Pukul : ${String(items.time_start).substring(0, 5)} - ${String(items.time_end).substring(0, 5)}\n    Kuota : ${items.quota ? String(items.quota) : '-'}\n    Total reservasi sebanyak : ${items.total_reservation ? String(items.total_reservation) : '0'}\n    Lokasi praktek : ${items.location ? String(items.location) : '-'}\n ${indexs + 1 === item.session.length ? '\n' : ''}`
                                ])
                            })
                        })

                    })
                    console.log(data);
                    if (data.length > 0) {
                        let fix = ``
                        data.map((item, index) => {
                            let a = item
                            let b = encodeURI(a)
                            fix += b
                            console.log(a);
                        })
                        // window.open(`https://wa.me/6281296258997?text=${fix}`, '_blank');
                        if (rowData[15]) {
                            window.open(`https://wa.me/62${rowData[15]}?text=${fix}`, '_blank');
                        } else {
                            setMessageAlert("Nomor HP Dokter Tidak Ditemukan")
                            setStatusAlert('warning')
                            setOpenAlert(true)
                        }
                    }
                }
            }

        })
    }


    const columns = [
        // {
        //     label: "No",
        //     options: {
        //         filter: false,
        //         customHeadRender: (columnMeta) => (
        //             <TableCell style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
        //                 <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
        //             </TableCell>
        //         ),
        //     }
        // },
        {
            label: "Nama Klinik",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 170, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Nama Dokter",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 170, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Tanggal",
            options: {
                sort: true,
                filter: true,
                filterType: 'custom',
                resetFilter: () => {
                    console.log('masuk');
                },
                onFilterChange: (columnChanged, filterList) => {
                    console.log(`onFilterChange columnChanged: ${columnChanged}`);
                    console.log(filterList);
                },
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (a, b, c, d, e, f) => (
                        <div style={{ marginTop: -16 }}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    margin="normal"
                                    label="Tgl. Mulai"
                                    format="dd/MM/yyyy"
                                    // clearable
                                    value={validFrom}
                                    // maxDate={new Date().setDate(new Date().getDate() - 1)}
                                    onChange={(date) => {
                                        setValidFrom(date)
                                        if (validTo === null) {
                                            setValidTo(date)
                                        }
                                        date === null ? updateDateRange(format(new Date(), 'yyyy-MM-dd'), validTo === null ? format(new Date(date), 'yyyy-MM-dd') : format(new Date(validTo), 'yyyy-MM-dd')) : updateDateRange(format(new Date(date), 'yyyy-MM-dd'), validTo === null ? format(new Date(date), 'yyyy-MM-dd') : format(new Date(validTo), 'yyyy-MM-dd'))
                                        // forceUpdate()
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    ),
                },
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 77, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            options: {
                display: false,
                filterType: 'custom',
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (filterList, onChange, index, column) => (
                        <div style={{ marginTop: -16 }}>
                            <FormGroup column>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        margin="normal"
                                        // clearable
                                        label="Tgl. Selesai"
                                        format="dd/MM/yyyy"
                                        // maxDate={new Date().setDate(new Date().getDate() - 1)}
                                        minDate={validFrom !== null && validFrom}
                                        value={validTo}
                                        onChange={(date) => {
                                            setValidTo(date)
                                            if (validFrom === null && date !== null) {
                                                setValidFrom(new Date())
                                            }
                                            if (date === null) {
                                                getDataTable()
                                                setDataFilter(null)
                                            } else {
                                                updateDateRange(validFrom === null ? format(new Date(), 'yyyy-MM-dd') : format(new Date(validFrom), 'yyyy-MM-dd'), format(new Date(date), 'yyyy-MM-dd'))
                                            }
                                            // forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormGroup>
                        </div>
                    ),
                }
            }
        }, {
            label: "Sesi",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 100, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Opsi Pembayaran",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 170, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Total Kuota",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 80, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Kuota BPJS",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 80, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Total Reservasi",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 80, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Reservasi Umum",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 80, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Reservasi Jaminan",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 80, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Reservasi BPJS",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 80, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "Reservasi Batal",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 80, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            label: "No. Antrian Terakhir",
            options: {
                sort: true,
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{ ...style, top: 0, zIndex: 10, backgroundColor: 'white', width: 100 }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt', fontFamily: 'Poppins', fontWeight: '500' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 80, }}>
                            {val}
                        </div>
                    )
                }
            }
        }, {
            name: "Aksi",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex' }}>
                            <LightTooltip title={"Reminder"} arrow>
                                <button
                                    onClick={() => copyText(tableMeta)}
                                    style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent'
                                    }}>
                                    <NotificationsIcon style={{ color: '#519d6d' }} />
                                </button>
                            </LightTooltip>
                        </div>
                    )
                }
            }
        }, {
            name: '',
            options: {
                filter: false,
                display: false
            }
        },
        {
            name: '',
            options: {
                filter: false,
                display: false
            }
        }
    ]

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ paddingTop: 10, position: 'relative', height: props.height - 100, overflow: 'auto' }}>
            {loading && (loadingComponent)}
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ minHeight: 600, width: props.width - (props.open === true ? 370 : 120) }}>
                {dataFilter === null ?
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            columns={columns}
                            data={dataTable}
                            options={options}
                        />
                    </MuiThemeProvider>
                    :
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            columns={columns}
                            data={dataFilter}
                            options={options}
                        />
                    </MuiThemeProvider>
                }
            </div>
        </div>
    )
}
